<template>
<div style="padding: 0 20px;">
  <order-content :orderObj="orderInfoObj"></order-content>
  <!-- 服务过程记录 -->
  <el-form size="small" style="margin: 20px 0 0" :model="handleForm" ref="handleForm" :rules="handleFormRules" label-width="90px" class="demo-ruleForm my-form">
    <el-row>
      <el-col :span="12" style="padding-right: 10px;box-sizing: border-box">
        <el-form-item label="服务商" prop="supplier_org_id">
          <el-select v-fixZoom v-if="role !== 'company'" class="my-form-inpt" style="width: 100%" v-model="handleForm.supplier_org_id" placeholder="请选择" @change="changeSupplier">
            <el-option v-for="item in allSupplier" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
          <div class="inpt-form" v-else><span>{{orderRow.supplier_name}}</span></div>
        </el-form-item>
        <el-form-item label="开始时间" prop="start_svs_tm">
          <el-date-picker v-fixZoom class="my-form-inpt" style="width: 100%" value-format="yyyy-MM-dd HH:mm:ss" default-time="12:00:00" v-model="handleForm.start_svs_tm" type="datetime" placeholder="请选择"></el-date-picker>
        </el-form-item>
        <el-form-item label="完成地址" prop="">
          <el-radio-group v-model="isHome" style="margin-left: 10px">
            <el-radio :label="1">一致</el-radio><el-radio :label="2">不一致</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="完成备注" prop="">
          <el-input class="my-form-inpt" v-model="handleForm.remark" placeholder="请输入"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" style="padding-left: 10px;box-sizing: border-box">
        <el-form-item label="服务人员" prop="supplier_person_id">
          <el-select v-fixZoom class="my-form-inpt" style="width: 100%" v-model="handleForm.supplier_person_id" placeholder="请选择">
            <el-option v-for="item in supplierorgpersons" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="完成时间" prop="times">
          <el-input class="my-form-inpt" type="number" placeholder="请输入"
                    v-model="handleForm.times">
            <template slot="append">小时</template>
          </el-input>
        </el-form-item>
        <el-form-item label="其他地址" prop="service_address" v-if="isHome === 2">
          <el-input class="my-form-inpt" v-model="handleForm.service_address" placeholder="请输入"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <!--  拓展确认字段  -->
    <el-row>
      <el-col :span="12" v-for="(item, index) in sureArr" :key="index" style="box-sizing: border-box" :style="{paddingLeft: index % 2 === 0 ? '' : '10px', paddingRight: index % 2 === 0 ? '10px' : ''}">
        <div style="height: 50px">
          <div style="height: 32px;line-height:32px;font-size:14px;text-align:center;width: 90px;float: left;color: #ffffff;background: #3D83F3;
                border-radius: 5px 5px 5px 5px;"><span v-if="item.required === 1" style="color: #F56C6C">*</span><span>{{item.key}}</span></div>
          <div style="height: 32px;width: calc(100% - 100px);margin-left: 10px;float: left"><el-input class="my-form-inpt" size="small" v-model="item.value" placeholder="请输入"></el-input></div>
        </div>
      </el-col>
    </el-row>
    <!--  拓展字段确认照片  -->
    <el-row>
      <el-col :span="24" v-for="(item, index) in pictureArr" :key="index" style="margin-bottom: 20px">
        <div style="height: 123px">
          <div style="height: 123px;line-height:32px;font-size:14px;text-align:center;width: 90px;float: left;color: #ffffff;background: #3D83F3;
                border-radius: 5px 5px 5px 5px;"><span v-if="item.required === 1" style="color: #F56C6C">*</span><span>{{item.key}}</span></div>
          <div style="width: calc(100% - 100px);margin-left: 10px;float: left;height: 123px;background: #FFFFFF;border-radius: 5px 5px 5px 5px;box-sizing: border-box;border: 1px solid #3D83F3">
            <div class="inpt-form" style="padding: 15px 0 0 10px;box-sizing: border-box;background: #FFFFFF;">
              <el-upload class="avatar-uploader" action="#" :auto-upload="false"
                         :show-file-list="false" :on-exceed="handleExceed"
                         :on-change="(file, fileList) => {handleChange(file, fileList, index, item.key)}"
                         list-type="picture" :ref="'upload' + index">
                <img v-if="item.value !== ''" :src="item.value" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <!--  服务照片  -->
    <el-row>
      <el-col :span="24">
        <div style="height: 123px">
          <div style="height: 123px;line-height:32px;font-size:14px;text-align:center;width: 90px;float: left;color: #ffffff;background: #3D83F3;
                border-radius: 5px 5px 5px 5px;"><span>服务照片</span></div>
          <div style="width: calc(100% - 100px);margin-left: 10px;height: 123px;float: left;background: #FFFFFF;border-radius: 5px 5px 5px 5px;box-sizing: border-box;border: 1px solid #3D83F3">
            <div class="inpt-form" style="padding: 15px 0 0 10px;box-sizing: border-box;background: #FFFFFF;">
              <el-upload class="upload-img1" action="#" list-type="picture-card" accept=".png,.jpg,jpeg"
                         :auto-upload="false" :on-preview="handlePictureCardPreview"
                         :on-remove="handleRemove1" :on-success="handleSuccess" :on-error="handleError"
                         :on-change="handleChange1" :limit="10" :file-list="dialogImageUrlArray1" ref="upload1">
                <i class="el-icon-plus"></i>
              </el-upload>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </el-form>
  <div style="height: 50px;margin-top: 30px">
    <el-row style="margin: 0 30px">
      <el-col :span="12">
        <div class="cancel-btn1" @click="closeOpen()"><span>取消</span></div>
      </el-col>
      <el-col :span="12">
        <div class="send-btn1" @click="submitHandle()"><span>确定</span></div>
      </el-col>
    </el-row>
  </div>
  <el-dialog :visible.sync="dialogVisible" width="800px" append-to-body>
    <div style="text-align: center">
      <img style="max-width: 100%" :src="dialogImageUrl" alt="">
    </div>
  </el-dialog>
</div>
</template>

<script>
import {uploadfile} from '../../../api/yanglaoyuan'
import {
  handlesupplierservicerecord,
  querysupplierorgnotype,
  querysupplierorgperson,
  querysupplierorgpersonbyso
} from '../../../api/serviceMark'
import orderContent from '../../servicemanagement/childComponents/orderContent.vue'
export default {
  name: 'orderHandleOpen',
  model: {
    prop: 'recordShow',
    event: 'change'
  },
  props: {
    orderObj: {
      type: Object,
      default: null
    },
    soOptions: {
      type: Array,
      default: null
    }
  },
  components: {orderContent},
  data () {
    return {
      orderInfoObj: {
        row: '',
        type: 'orderHandle'
      },
      isopen: false,
      orderRow: {
        person_name: '',
        person_sex: '',
        birthday: '',
        st_id: '',
        begin_time: '',
        end_time: '',
        home_address: '',
        remark: '',
        supplier_name: ''
      },
      types: [],
      optionFrequency: [], // 服务频率
      height2: 200,
      dialogImageUrlArray1: [], // 服务照片
      // 发起拓展字段
      serviceArr: [],
      // 确认拓展字段
      sureArr: [],
      pictureArr: [],
      handleForm: {
        service_address: '',
        supplier_org_id: '',
        supplier_person_id: '',
        svs_tm: '',
        start_svs_tm: '',
        remark: '',
        times: 2 // 完成时长
      },
      handleFormRules: {
        supplier_org_id: [
          { required: true, message: '请选择服务商', trigger: 'change' }
        ],
        supplier_person_id: [
          { required: true, message: '请选择服务人员', trigger: 'change' }
        ],
        svs_tm: [
          { required: true, message: '请选择完成时间', trigger: 'change' }
        ],
        start_svs_tm: [
          { required: true, message: '请选择完成时间', trigger: 'change' }
        ],
        service_address: [
          { required: true, message: '请输入完成地址', trigger: 'blur' }
        ],
        times: [
          { required: true, message: '请输入完成地址', trigger: 'blur' }
        ]
      },
      isHome: 1,
      dialogVisible: false,
      dialogImageUrl: '',
      allSupplier: [], // 服务商
      supplierorgpersons: [], // 服务人员
      role: ''
    }
  },
  created () {
    console.log('orderid', this.orderObj.row)
    this.types = this.orderObj.types
    this.orderInfoObj.row = this.orderObj.row
    this.orderInfoObj.row.service_name = this.getUpTypeName(this.orderInfoObj.row.st_id)
    this.orderInfoObj.row.pps_remark = this.orderInfoObj.row.remark
    // console.log(12345, this.orderInfoObj.row.service_name)
    this.role = this.$store.state.user.role
    if (this.role !== 'company') {
      this.getAllSupplier()
    }
    this.orderRow = this.orderObj.row
    this.handleForm.supplier_person_id = this.orderRow.supplier_person_id !== 0 ? this.orderRow.supplier_person_id : ''
    this.handleForm.supplier_org_id = this.orderRow.supplier_org_id !== 0 ? this.orderRow.supplier_org_id : ''
    this.handleForm.start_svs_tm = this.orderRow.begin_time !== '0000-00-00 00:00:00' ? this.orderRow.begin_time : ''

    if (this.orderRow.begin_time && this.orderRow.begin_time !== '0000-00-00 00:00:00' && this.orderRow.end_time && this.orderRow.end_time !== '0000-00-00 00:00:00') {
      let startTime = new Date(this.orderRow.begin_time) // 开始时间
      let endTime = new Date(this.orderRow.end_time) // 结束时间
      let usedTime = endTime - startTime // 相差的毫秒数
      let hours = Math.floor(usedTime / (3600 * 1000)) // 相差的小时数
      this.handleForm.times = hours
      console.log('服务时长', this.handleForm.times)
    }

    this.supplierId = this.orderRow.ss_id !== 0 ? this.orderRow.ss_id : ''
    // this.handleForm.service_address = this.orderRow.home_address
    if (this.role === 'company') {
      this.handleForm.supplier_org_id = this.$store.state.user.orgid
      this.orderRow.supplier_name = this.$store.state.user.orgname
    }
    if (this.handleForm.supplier_org_id !== 0 && this.handleForm.supplier_org_id !== '') {
      // this.querySupplierPerson()
      if (this.role === 'company') {
        this.querySupplierPersoncompany()
      } else {
        this.querySupplierPerson()
      }
    }
    if (this.orderObj.row.servicerequirements) {
      this.serviceArr = this.orderObj.row.servicerequirements[0]
      this.sureArr = this.orderObj.row.servicerequirements[1]
      this.pictureArr = this.orderObj.row.pictureArr
    }
    let arr = []
    // let base = window.location.host.indexOf('localhost') === 0 ? 'https://jiaold.com' : window.location.protocol + '//' + window.location.host
    this.pictureArr.forEach(item => {
      item.fileid = ''
      item.value = ''
      arr.push(item)
    })
    this.pictureArr = arr
    if (this.serviceArr.length > 0) {
      let num = Math.round(this.serviceArr.length / 2)
      this.height2 = 200 + 28 + num * 40
    }
  },
  methods: {
    // 全部服务商
    getAllSupplier () {
      let params = {
        page: 1,
        size: 99999
      }
      querysupplierorgnotype(params).then(res => {
        this.allSupplier = res.data.org
      })
    },
    changeSupplier (id) {
      this.querySupplierPerson()
    },
    // 服务商人员
    querySupplierPersoncompany () {
      let data = {
        so_id: this.handleForm.supplier_org_id
      }
      querysupplierorgpersonbyso(data).then(res => {
        this.supplierorgpersons = res.data.supplierorgpersons
      }).catch(() => {})
    },
    querySupplierPerson () {
      let data = {
        so_id: this.handleForm.supplier_org_id
      }
      querysupplierorgperson(data).then(res => {
        this.supplierorgpersons = res.data.supplierorgpersons
      }).catch(() => {})
    },
    getAgeDesc (birthDate) {
      let result = ''
      let age = this.util.getAgeByBirth(birthDate)
      if (age === '') {
        result = '--'
      } else {
        result = age + '岁'
      }
      return result
    },
    getUpTypeName (upid) {
      let name = ''
      let upids = this.getOrgName1(parseInt(upid), [])
      for (let i = 0; i < upids.length; i++) {
        for (let j = 0; j < this.types.length; j++) {
          if (parseInt(upids[i]) === this.types[j].id) {
            name = this.types[j].typename + ' / ' + name
          }
        }
      }
      return name !== '' ? name.substring(0, name.length - 3) : ''
    },
    getOrgName1 (upid, arr) {
      arr.push(upid)
      for (let i = 0; i < this.types.length; i++) {
        if (parseInt(upid) === this.types[i].id) {
          arr = this.getOrgName1(this.types[i].upid, arr)
        }
      }
      return arr
    },
    // 上传图片
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    handleSuccess (res, file, fileList) {
      this.$message.success('上传成功')
    },
    // eslint-disable-next-line handle-callback-err
    handleError (err, file, fileList) {
      this.$message.error('上传失败')
    },
    // 拓展字段照片
    handleRemove (file, fileList) {
      for (let i = 0; i < this.pictureArr.length; i++) {
        for (let j = 0; j < this.pictureArr[i].dialogImageUrl.length; j++) {
          if (this.pictureArr[i].dialogImageUrl[j].url === file.url) {
            this.pictureArr[i].dialogImageUrl.remove(this.pictureArr[i].dialogImageUrl[j])
          }
        }
      }
    },
    handleChange (file, fileList, index, filename) {
      console.log(filename)
      let types = ['image/png', 'image/jpeg', 'image/jpg']
      if (types.indexOf(file.raw.type) === -1) {
        this.$message.error('上传图片只能是 .png .jpeg .jpg 格式!')
        return
      }
      let obj = {
        raw: file.raw,
        filename: filename,
        domain: window.location.host.indexOf('localhost') === 0 ? 'https://jiaold.com' : window.location.protocol + '//' + window.location.host
      }
      this.$message({message: '正在上传。', type: 'warning', duration: 0})
      uploadfile(obj).then(res => {
        this.$message.closeAll()
        this.$message({ message: '成功上传图片', type: 'success' })
        file.filename = res.data.filename
        this.pictureArr[index].value = res.data.fileurl
        this.pictureArr[index].fileid = res.data.fileid
        console.log(this.pictureArr)
      }).catch(() => {
        this.$message.closeAll()
        let aa = `upload` + index
        this.$refs[aa].uploadFiles = this.dialogImageUrlArray
        this.$message({ message: '上传图片失败', type: 'error' })
      })
    },
    // 服务照片
    handleExceed (files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },
    handleRemove1 (file, fileList) {
      for (let i = 0; i < this.dialogImageUrlArray1.length; i++) {
        if (this.dialogImageUrlArray1[i].url === file.url) {
          this.dialogImageUrlArray1.remove(this.dialogImageUrlArray1[i])
        }
      }
    },
    handleChange1 (file, fileList) {
      let types = ['image/png', 'image/jpeg', 'image/jpg']
      if (types.indexOf(file.raw.type) === -1) {
        this.$message.error('上传头像图片只能是 .png .jpeg .jpg 格式!')
        return
      }
      let obj = {
        raw: file.raw,
        filename: '服务照片',
        domain: window.location.host.indexOf('localhost') === 0 ? 'https://jiaold.com' : window.location.protocol + '//' + window.location.host
      }
      this.$message({message: '正在上传。', type: 'warning', duration: 0})
      uploadfile(obj).then(res => {
        this.$message.closeAll()
        this.$message({ message: '成功上传图片', type: 'success' })
        file.filename = res.data.filename
        file.fileid = res.data.fileid
        this.dialogImageUrlArray1.push(file)
        console.log(this.dialogImageUrlArray1)
      }).catch(() => {
        this.$message.closeAll()
        this.$refs.upload1.uploadFiles = this.dialogImageUrlArray1
        this.$message({ message: '上传图片失败', type: 'error' })
      })
    },
    closeOpen () {
      this.$emit('change', false)
    },
    submitHandle () {
      if (this.handleForm.supplier_org_id === '' || this.handleForm.supplier_person_id === '') {
        this.$message({ message: '请填写必填内容。', type: 'warning' })
        return
      }
      let fileids = ''
      this.dialogImageUrlArray1.forEach(item => {
        let fileid = item.fileid + ''
        if (fileids === '') {
          fileids = fileid
        } else {
          fileids = fileids + ',' + fileid
        }
      })
      let arr = []
      let isTrue1 = false
      this.pictureArr.forEach(item => {
        if (item.required === 1 && item.value === '') {
          isTrue1 = true
        }
        let obj = {key: item.key, value: item.fileid, required: item.required}
        arr.push(obj)
      })

      let servicerequirements = []
      let isTrue2 = false
      let arr1 = []
      this.sureArr.forEach(item => {
        if (item.key !== '') {
          let obj = {key: item.key, value: item.value, required: (item.required || item.required === 0) ? item.required : 0}
          if (item.required === 1 && item.value === '') {
            isTrue2 = true
          }
          arr1.push(obj)
        }
      })
      if (isTrue1 || isTrue2) {
        this.$message({ message: '请填写完整内容。', type: 'warning' })
        return
      }
      servicerequirements[0] = this.serviceArr
      servicerequirements[1] = arr1
      let startTime = new Date(this.handleForm.start_svs_tm).getTime()
      let endTime = 3600 * 1000 * parseFloat(this.handleForm.times)
      // eslint-disable-next-line no-extend-native
      Date.prototype.format = this.validate.format
      const date = new Date(endTime + startTime).format('yyyy-MM-dd hh:mm:ss')
      let data = {
        'id': 0,
        'pid': this.orderObj.row.pid,
        'pss_id': this.orderObj.row.id,
        'remark': this.handleForm.remark,
        start_svs_tm: this.handleForm.start_svs_tm,
        'svs_tm': date,
        'sys_person_id': this.$store.state.user.syspersonid,
        'supplier_org_id': this.handleForm.supplier_org_id,
        'supplier_person_id': this.handleForm.supplier_person_id,
        'service_address': this.orderRow.home_address,
        'service_lat': '',
        'service_lng': '',
        'service_img': fileids,
        'service_requirements': JSON.stringify(servicerequirements),
        'picture_requirements': JSON.stringify(arr),
        'service_requirements_tag': this.orderObj.row.service_requirements_tag, // 发起字段
        'picture_requirements_tag': arr.length > 0 ? 1 : 0,
        backup_address: this.isHome === 1 ? this.orderRow.home_address : this.handleForm.service_address,
        backup_phone: this.orderObj.row.backup_phone,
        orderid: this.orderObj.row.orderid
      }
      console.log(data)
      handlesupplierservicerecord(data).then(res => {
        this.$notify({ title: '成功', message: '成功处理服务单', type: 'success', duration: 2000 })
        this.$emit('change', false)
        this.$emit('closeOrder')
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datamanagement/childComponents/orderHandleOpen.vue